import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb, faHandshake, faPeopleArrows, faBalanceScale, faHeart } from '@fortawesome/free-solid-svg-icons';

const CarouselItem = ({ title, description, icon }) => {
  // Defined icons for each item
  const icons = {
    innovative: faLightbulb,
    committed: faHandshake,
    together: faPeopleArrows,
    integrity: faBalanceScale,
    care: faHeart,
  };

  return (
    <div className="item hover:bg-gray-100">
      <div className="ourvaluebox p-5 border border-gray-900 rounded-xl shadow-xl hover:shadow-xl transition duration-300 text-justify">
        <div className="flex items-center justify-center bg-[#023B8D] text-gray-400 rounded-full w-16 h-16 mb-4 text-center">
          <FontAwesomeIcon icon={icons[icon]} className="text-[#C5B358] text-3xl " /> 
        </div>
        <div className="text-center">
          <h4 className="text-lg font-bold text-center">{title}</h4>
          <p className="text-gray-600 text-lg">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default CarouselItem;
